import { ref, computed } from 'vue';

export default (isHovered = false) => {
  const hovered = ref(isHovered);
  const classes = computed(() => ({
    'c-textarea-hover': hovered.value,
  }));
  return { hovered, classes };
};
